<template>
  <div class="tooth-wrap mt0">
    <div class="teeth">
      <svg
        width="870"
        height="132"
        viewBox="0 0 958 146"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Tooth
          v-for="i in 32"
          :key="i"
          :form="i"
          show-number
          :color="needToHighlight(i)"
        />
        <ToothUnity
          v-for="i in 32"
          :key="'unity'+i"
          :i="i"
          :visible="isUnited(i)"
          class="info"
          in-orders
        />
      </svg>
    </div>
  </div>
</template>

<script>
  import Tooth from '@/components/Tooth';
  import ToothUnity from '@/components/ToothUnity';
  import {TYPES} from '@/utils/constants/order-types';

  const INACTIVE_COLOR = '#CCCED9';

  export default {
    name: 'TeethInfo',
    components: {ToothUnity, Tooth},
    props: {
      teeth: {
        type: Array,
        required: true,
      },
      products: {
        type: Array,
        default: () => ([]),
      },
    },
    computed: {
      unitedTeeth () {
        return this.products.map(product => ({
          type: product.type,
          color: TYPES.find(type => type.slug === product.type)?.color,
          teeth: product.teeth?.map(tooth => tooth.type),
        })) || [];
      },
      bridges () {
        const bridgeArrs = this.products.map(product => product.bridges.map(bridge => bridge.teeth.map(tooth => tooth.type))).flat();
        const bridges = bridgeArrs.map(bridgeArr => bridgeArr.filter((element, index) => index < bridgeArr.length - 1)).flat();

        bridges.forEach((val, i) => {
          if (val >= 9 && val <= 16) bridges[i]++;
          if (val >= 25 && val <= 32) bridges[i]++;
        });

        if (bridges.includes(8) && !bridges.includes(9)) bridges.push(9);
        if (bridges.includes(9) && !bridges.includes(8)) bridges.push(8);
        if (bridges.includes(24) && !bridges.includes(25)) bridges.push(25);
        if (bridges.includes(25) && !bridges.includes(24)) bridges.push(24);

        bridges.sort((a, b) => a - b);
        return bridges;
      },
    },
    methods: {
      needToHighlight (i) {
        const products = this.unitedTeeth.filter(product => product.teeth.includes(i));
        if (products.length > 1) {
          const abutm = products.find(product => product.type === 'abutment');
          const notAbutm = products.find(product => product.type !== 'abutment');
          return abutm ? abutm.color : (notAbutm.color || INACTIVE_COLOR);
        }
        if (products.length === 1) {
          return products?.[0]?.color;
        }
        return INACTIVE_COLOR;
      },
      isUnited (i) {
        return this.bridges.includes(i);
      },
    },
  };
</script>

<style scoped>
  g >>> .w {
    fill: white;
  }
  g {
    fill: #CCCED9;
  }
  g.selected {
    fill: #4C5060;
  }
  svg { /*MYSTYLE*/
    max-width: 100%;
  }
  @media screen and (max-width: 479px){ /*MYSTYLE*/
    svg {
      height: auto;
    }
  }
</style>
